import { useTranslation } from "react-i18next";

/**
 * Textos bilingües en línea, como en Feature Flags: `tr("Guardar", "Save")`.
 * Devuelve también el idioma para elegir el campo `es`/`en` de lo que manda la
 * API (el catálogo de operaciones de riesgo).
 */
export function useSecurityText() {
  const { i18n } = useTranslation();
  const lang: "es" | "en" = (i18n.language || "es").startsWith("en") ? "en" : "es";
  const tr = (es: string, en: string) => (lang === "en" ? en : es);
  return { lang, tr };
}

/** Fecha corta y legible en el idioma de la pantalla. */
export const formatDate = (iso: string | null | undefined, lang: "es" | "en"): string => {
  if (!iso) return "";
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return "";
  return date.toLocaleDateString(lang === "en" ? "en-US" : "es-MX", {
    day: "numeric",
    month: "long",
    year: "numeric",
  });
};
